import React from "react"
import { useSelector } from "react-redux"
import { App } from "components/views/app/App"
import Loading from "components/views/Loading"
import { getUserInfoLoaded } from "reducers/userInfo"
import { getIsBenefitConfigurationLoaded } from "reducers/benefitConfiguration"
import { BenefitEnrollmentProvider } from "components/context/enrollment/BenefitEnrollmentContext"
import { DeductibleProvider } from "components/context/user/DeductibleContext"
import { FeatureToggleContextProvider } from "components/context/feature-toggle/FeatureToggleContext"

const AppContainer = () => {
  const isUserInfoLoaded = useSelector(getUserInfoLoaded)
  const isBenefitConfigurationLoaded = useSelector(getIsBenefitConfigurationLoaded)

  const isDataLoaded = [isUserInfoLoaded, isBenefitConfigurationLoaded].every((i) => i)

  return isDataLoaded ? (
    <FeatureToggleContextProvider>
      <DeductibleProvider>
        <BenefitEnrollmentProvider>
          <App />
        </BenefitEnrollmentProvider>
      </DeductibleProvider>
    </FeatureToggleContextProvider>
  ) : (
    <Loading />
  )
}

export { AppContainer }
